import styled from "styled-components";
import { theme } from "../../theme";

export const Container = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 40px;

  button {
    border: none;
    background-color: initial;
    padding: 0;
    color: ${theme.colors.textSecondary};
    cursor: pointer;
    font-family: ${theme.fonts.body};
  }
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  margin: 0;
  color: ${theme.colors.text};
  font-weight: 600;
  font-family: ${theme.fonts.body};
`;

export const Section = styled.section`
  margin-bottom: 24px;
  padding: 20px;
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.borderLight};
  border-radius: ${theme.radius.lg}px;
  box-shadow: ${theme.shadows.sm};
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  margin: 0 0 15px;
  color: ${theme.colors.text};
  padding-bottom: 20px;
  font-weight: 600;
  font-family: ${theme.fonts.body};
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 30px;

  .full-width {
    grid-column: 1 / -1;
  }

  .fill-width {
    width: fit-content;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Label = styled.label`
  font-size: 13px;
  color: ${theme.colors.textSecondary};
  font-weight: 600;
  font-family: ${theme.fonts.body};
`;

export const Input = styled.input`
  padding: 8px 10px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.md}px;
  font-size: 14px;
  font-family: ${theme.fonts.body};
  color: ${theme.colors.text};
  background: ${theme.colors.surface};

  &:focus {
    outline: none;
    border-color: ${theme.colors.accent};
  }
`;

export const Select = styled.select`
  padding: 8px 10px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.md}px;
  font-size: 14px;
  font-family: ${theme.fonts.body};
  background: ${theme.colors.surface};
  color: ${theme.colors.text};

  &:focus {
    outline: none;
    border-color: ${theme.colors.accent};
  }
`;

export const SaveButton = styled.button`
  padding: 10px 24px;
  background: ${theme.colors.success};
  color: #fff;
  border: none;
  border-radius: ${theme.radius.md}px;
  cursor: pointer;
  font-size: 14px;
  font-family: ${theme.fonts.body};
  font-weight: 500;
  margin-top: 15px;
  transition: background 0.2s;

  &:hover {
    background: ${theme.colors.successHover};
  }

  &:disabled {
    background: ${theme.colors.border};
    cursor: not-allowed;
  }
`;

export const Loading = styled.p`
  color: ${theme.colors.textSecondary};
  font-family: ${theme.fonts.body};
`;

// Image item styles
export const ImageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ImageItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border: 1px solid ${theme.colors.borderLight};
  border-radius: ${theme.radius.md}px;
  cursor: grab;

  &:dragging {
    opacity: 0.5;
  }

  &:hover {
    background: ${theme.colors.bg};
  }
`;

export const Thumbnail = styled.div`
  width: 150px;
  height: 100px;
  border-radius: ${theme.radius.sm}px;
  overflow: hidden;
  flex-shrink: 0;
  background: ${theme.colors.bg};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const ThumbnailImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const ImageInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
`;

export const ImageTitleInput = styled.input`
  padding: 4px 8px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.sm}px;
  font-size: 13px;
  font-family: ${theme.fonts.body};
  color: ${theme.colors.text};

  &:focus {
    outline: none;
    border-color: ${theme.colors.accent};
  }
`;

export const ImageFileName = styled.span`
  font-size: 12px;
  color: ${theme.colors.textSecondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DeleteButton = styled.button`
  padding: 4px 10px;
  background: ${theme.colors.danger};
  color: #fff;
  border: none;
  border-radius: ${theme.radius.sm}px;
  cursor: pointer;
  font-size: 12px;
  font-family: ${theme.fonts.body};
  flex-shrink: 0;
  transition: background 0.2s;

  &:hover {
    background: ${theme.colors.dangerHover};
  }
`;

export const AddButton = styled.button`
  padding: 8px 16px;
  background: ${theme.colors.accent};
  color: #fff;
  border: none;
  border-radius: ${theme.radius.md}px;
  cursor: pointer;
  font-size: 13px;
  font-family: ${theme.fonts.body};
  font-weight: 500;
  margin-top: 10px;
  transition: background 0.2s;

  &:hover {
    background: ${theme.colors.accentHover};
  }
`;

// List item styles
export const ListList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DropZone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 13px;
  font-weight: 500;
  color: ${(props) =>
    props.$isOver ? theme.colors.accent : theme.colors.textSecondary};
  background-color: ${(props) =>
    props.$isOver
      ? "#e8f2ff"
      : props.$active
        ? theme.colors.bg
        : "transparent"};
  border: ${(props) =>
    props.$active
      ? props.$isOver
        ? `2px dashed ${theme.colors.accent}`
        : `2px dashed ${theme.colors.border}`
      : "none"};
  border-radius: ${theme.radius.sm}px;
  height: ${(props) =>
    props.$active ? (props.$isOver ? "36px" : "22px") : "0px"};
  margin: ${(props) => (props.$active ? "4px 0" : "0")};
  opacity: ${(props) => (props.$active ? 1 : 0)};
  overflow: hidden;
  transition: all 0.15s ease-in-out;
  pointer-events: ${(props) => (props.$active ? "all" : "none")};
  user-select: none;

  * {
    pointer-events: none;
  }
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: ${theme.colors.bg};
  border: 1px solid ${theme.colors.borderLight};
  border-radius: ${theme.radius.md}px;
  cursor: grab;

  &:dragging {
    opacity: 0.5;
  }

  &:hover {
    background: ${theme.colors.borderLight};
  }
`;

export const ListTitleInput = styled.input`
  flex: 1;
  padding: 6px 10px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.sm}px;
  font-size: 14px;
  font-family: ${theme.fonts.body};
  color: ${theme.colors.text};

  &:focus {
    outline: none;
    border-color: ${theme.colors.accent};
  }
`;

// Modal styles
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const Modal = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.radius.lg}px;
  padding: 20px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: ${theme.shadows.lg};
`;

export const ModalTitle = styled.h3`
  margin: 0 0 15px;
  font-size: 16px;
  color: ${theme.colors.text};
  font-weight: 600;
  font-family: ${theme.fonts.body};
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 15px;
  justify-content: space-between;
`;

export const CancelButton = styled.button`
  padding: 8px 16px;
  background: ${theme.colors.borderLight};
  color: ${theme.colors.text};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.md}px;
  cursor: pointer;
  font-size: 13px;
  font-family: ${theme.fonts.body};
  width: 100%;
  max-width: 50%;
  transition: background 0.2s;

  &:hover {
    background: ${theme.colors.border};
  }
`;

export const ConfirmButton = styled.button`
  padding: 8px 16px;
  background: ${theme.colors.success};
  color: #fff;
  border: none;
  border-radius: ${theme.radius.md}px;
  cursor: pointer;
  font-size: 13px;
  font-family: ${theme.fonts.body};
  width: 100%;
  max-width: 50%;
  transition: background 0.2s;

  &:hover {
    background: ${theme.colors.successHover};
  }
`;

export const OptionButton = styled.button`
  display: block;
  width: 100%;
  padding: 10px;
  margin-bottom: 8px;
  background: ${theme.colors.bg};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.md}px;
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  font-family: ${theme.fonts.body};
  color: ${theme.colors.text};
  transition: background 0.2s;

  &:hover {
    background: ${theme.colors.borderLight};
  }
`;

export const OriginalPreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: ${theme.colors.bg};
  border: 1px dashed ${theme.colors.border};
  overflow: hidden;
  flex-shrink: 0;
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

export const EmptyPreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  font-family: ${theme.fonts.body};
  color: ${theme.colors.textSecondary};
`;

export const PreviewOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 50%;
  font-size: 13px;
  opacity: 0;
  transition: opacity 0.2s;
`;

export const PreviewImageWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: 100%;
  height: 100%;

  &:hover ${PreviewOverlay} {
    opacity: 1;
  }
`;

export const DragHandle = styled.span`
  color: ${theme.colors.textSecondary};
  font-size: 16px;
  cursor: grab;
  user-select: none;
`;
